import React from 'react'
import { useIntl } from 'react-intl'
import { Box, MenuItem, Select } from '@mui/material'
import { directorApi, dirSubjectsArgs } from '../../features/director/directorApi'
import { filterField, filterLabel } from '../../components/filterSelect/FilterSelect'
import { capitalize } from '../../utils/functions'
import { useDirectorSubject, useHeadScope } from '../head/headScope'

// Фильтр сервис басшысы рядом с «Барлық лектер»: «Пән» или (на «Оқушылар») «Пән басшысы».
// Вне кабинета директора ничего не рисует.
const DirectorSubjectFilter: React.FC<{ byHead?: boolean; withLabel?: boolean; filters?: Parameters<typeof dirSubjectsArgs>[0] }> = ({
    byHead = false,
    withLabel = false,
    filters,
}) => {
    const { formatMessage, locale } = useIntl()
    const { director } = useHeadScope()
    const { subjectId, setSubjectId } = useDirectorSubject()
    const { data: subjects = [] } = directorApi.useGetSubjectsQuery(dirSubjectsArgs(filters), { skip: !director })
    if (!director) return null

    const title = (s) => s[`title${capitalize(locale)}`] || s.titleRu
    const options = byHead
        ? subjects.flatMap((s) =>
              (s.headNames?.length ? s.headNames : ['-']).map((h) => ({ key: `${s.subjectId}:${h}`, value: s.subjectId, label: `${h} · ${title(s)}` })),
          )
        : subjects.map((s) => ({ key: String(s.subjectId), value: s.subjectId, label: title(s) }))
    // у одного предмета несколько басшы: значение одно, показываем первую строку
    const seen = new Set<number>()
    const unique = byHead ? options : options.filter((o) => (seen.has(o.value) ? false : (seen.add(o.value), true)))

    return (
        <Box>
            {withLabel && <Box sx={filterLabel}>{formatMessage({ id: byHead ? 'dirHead' : 'colSubject' })}</Box>}
            <Select
                size="small"
                displayEmpty
                value={subjectId ?? ''}
                onChange={(e) => setSubjectId(Number(e.target.value) || null)}
                renderValue={(v) =>
                    v ? unique.find((o) => o.value === v)?.label ?? '' : formatMessage({ id: byHead ? 'dirAllHeads' : 'salaryAllSubjects' })
                }
                sx={{ ...filterField, width: 'auto', minWidth: 200 }}
            >
                <MenuItem value="">{formatMessage({ id: byHead ? 'dirAllHeads' : 'salaryAllSubjects' })}</MenuItem>
                {unique.map((o) => (
                    <MenuItem key={o.key} value={o.value}>{o.label}</MenuItem>
                ))}
            </Select>
        </Box>
    )
}

export default DirectorSubjectFilter
